import { oneTimeSetup, sharedSetup, logCustomDatadogAction, logDatadogError, setDatadogRumContext } from "app/scripts/shared_setup"
import { runWhenIdle } from "shared/lib/utils"
import { initSentryBrowser } from "app/scripts/sentry_browser_setup"
import { attachNewBadgeForButtons } from "shared/scripts/new_badge_button"
import VanillaFittty from "shared/scripts/vanilla_fittty"
import RubberBandPinchColor from "app/scripts/rubber_band_pinch_color"
import BackButton from "app/scripts/back_button"
import toggleHelpWidgetVisibility from "shared/scripts/toggle_help_widget_visibility"
import lazyBGImageObserver from "app/scripts/lazy_bg_img_observer"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import { GenericSearchInputSetup } from "app/components/universal_search/generic_search_input"
import { UniversalSearchHeader } from "app/components/universal_search/header"

function sharedVanillaSetup() {
  oneTimeSetup()
  initSentryBrowser()
  GenericSearchInputSetup()
  UniversalSearchHeader()

  document.addEventListener("DOMContentLoaded", () => {
    sharedSetup()

    const tryProFreeButton = document.getElementById("try-pro-free")
    tryProFreeButton?.addEventListener("click", () => {
      logCustomDatadogAction?.("click_try_pro_free")
    }, { once: true })

    // Keep VanillaFittty in main path so text sizing doesn't shift line breaks on Applet cards (review feedback)
    VanillaFittty()

    runWhenIdle(() => {
      attachNewBadgeForButtons()
      lazyBGImageObserver()
      if (window.App.user?.id) toggleHelpWidgetVisibility()
    })
  })

  window.App = window.App || {}
  window.App = Object.assign(window.App, {
    storedFieldPath: (resolveUrl, liveChannelId = "") => {
      if (liveChannelId === "") {
        return `/stored_fields/options?resolve_url=${resolveUrl}`
      } else {
        return `/stored_fields/options?resolve_url=${resolveUrl}&live_channel_id=${liveChannelId}`
      }
    }
  })
  window.App.Comps = {}
  window.App.Scripts = {
    BackButton,
    RubberBandPinchColor,
    SetupUnifiedMobileMenu,
  }
  window.App.Utils = {
    logCustomDatadogAction,
    logDatadogError
  }
}

export { logCustomDatadogAction, setDatadogRumContext, sharedVanillaSetup }
